import {
  UserGroupIcon,
  Squares2X2Icon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  AcademicCapIcon,
  BookOpenIcon,
  CalculatorIcon,
  BeakerIcon,
} from "@heroicons/react/24/outline";


export const users = [
  {
    id: "USR001",
    name: "Michel Shen",
    role: "Educator",
    email: "Michel@school.com",
    lastLogin: "10 Aug 2025",
    appCount: 4,
    status: "Active",
  },
  {
    id: "USR002",
    name: "John Smith",
    role: "Student",
    email: "john@student.org",
    lastLogin: "10 Aug 2025",
    appCount: 6,
    status: "Inactive",
  },
  {
    id: "USR003",
    name: "Michael Chen",
    role: "Educator",
    email: "michael@admin.org",
    lastLogin: "10 Aug 2025",
    appCount: 7,
    status: "Active",
  },
];



export const userDetailApplications = [
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 98, color: "bg-green-500" },
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 68, color: "bg-orange-400" },
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 68, color: "bg-blue-600" },
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 28, color: "bg-orange-500" },
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 98, color: "bg-green-500" },
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 68, color: "bg-orange-400" },
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 68, color: "bg-blue-600" },
  { name: "Reading Comprehensen", users: "1,234 Active Users", progress: 28, color: "bg-orange-500" },
];


export const students = [
  {
    id: "USR001",
    name: "Michel Shen",
    avatar: "https://i.pravatar.cc/40?img=1",
    progress: 96,
    lastLogin: "2 hours ago",
    status: "Active",
  },
  {
    id: "USR002",
    name: "Sophia Lee",
    avatar: "https://i.pravatar.cc/40?img=2",
    progress: 86,
    lastLogin: "5 hours ago",
    status: "Active",
  },
  {
    id: "USR003",
    name: "David Kim",
    avatar: "https://i.pravatar.cc/40?img=3",
    progress: 46,
    lastLogin: "1 day ago",
    status: "Inactive",
  },
];

export const performanceData = [
  { week: "Week 1", avg: 78 },
  { week: "Week 2", avg: 82 },
  { week: "Week 3", avg: 85 },
  { week: "Week 4", avg: 89 },
];
export const milestones = [
  { name: "Reading Level 3", value: 34.2, color: "bg-green-500" },
  { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
  { name: "Science Fundamentals", value: 34.2, color: "bg-yellow-500" },
  { name: "MathMaster", value: 34.2, color: "bg-orange-500" },
  { name: "MathMaster", value: 34.2, color: "bg-blue-500" },
];




export const applicationTableHeaders = [
  { key: "application", label: "APPLICATION" },
  { key: "educator", label: "EDUCATOR" },
  { key: "avgScore", label: "AVG SCORE" },
  { key: "location", label: "LOCATION" },
  { key: "usageHours", label: "USAGE HOURS" },
  { key: "completion", label: "COMPLETION" },
];


export const applications = [
  {
    name: 'Math Master',
    icon: Squares2X2Icon,
    educator: {
      name: 'Michel Shen',
      id: 'USR001',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=MS',
    },
    avgScore: 86,
    location: 'California, USA',
    usageHours: 120,
    completion: 86,
  },
  {
    name: 'Science Lab',
    icon: BeakerIcon,
    educator: {
      name: 'Alice Johnson',
      id: 'USR002',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=AJ',
    },
    avgScore: 92,
    location: 'New York, USA',
    usageHours: 80,
    completion: 96,
  },
  {
    name: 'History Hub',
    icon: BookOpenIcon,
    educator: {
      name: 'John Doe',
      id: 'USR003',
      avatar: 'https://placehold.co/32x32/E9E2D9/4B4B4B?text=JD',
    },
    avgScore: 78,
    location: 'Texas, USA',
    usageHours: 60,
    completion: 70,
  },
];

export const ProgressBar = ({ percentage }) => {
  const barColor = percentage > 90 ? 'bg-green-500' : 'bg-orange-500';
  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5">
      <div className={`${barColor} h-2.5 rounded-full`} style={{ width: `${percentage}%` }}></div>
    </div>
  );
};


export const applicationUsageBarGraph = [
  { name: "Math Quest", usageHours: 60 },
  { name: "Science Explorer", usageHours: 45 },
  { name: "Reading Adventure", usageHours: 30 },
  { name: "Art Studio", usageHours: 21 },
  { name: "Art", usageHours: 21 },
];
